// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#login {
  font-weight: 400;
  font-size: 0.8em;
  line-height: 1.6em;
  font-family: "Open Sans", Frutiger, Calibri, "Myriad Pro", Myriad, sans-serif;
  color: #000;
  text-align: center;
  /* Flex container */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */
}
#login .card-login {
  background: rgba(251, 253, 248, 0.68);
  box-shadow: 11px 16px 83px rgba(64, 75, 5, 0.28);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  width: 557px;
  height: 415px;
  border-radius: 22px;
}
#login .card-login .content {
  width: 90%;
  margin: auto;
}
#login .card-login .bloc-page-title {
  margin-top: 30px;
  text-align: center;
  font-size: "DM Sans";
  font-weight: 700;
  margin-bottom: 20px;
}
#login .card-login .bloc-page-title .page-title {
  color: #5620e4;
  font-size: 28px;
}
#login .card-login .bloc-page-title .sub-title {
  font-size: 12px;
  opacity: 0.8;
  letter-spacing: 0.7px;
}
#login .card-login .bloc-page-title .img-logo {
  height: 80px;
  width: 151px;
}
#login .card-login .bloc-page-title .img-logo-telespazio {
  height: 80px;
  width: 270px;
}
#login .bloc-infos-login {
  color: white;
  text-align: left;
}
#login .bloc-infos-login .title {
  font-size: 5rem;
}
#login .bloc-infos-login .details {
  font-size: 1.1rem;
  margin-top: 45px;
}
#login mat-card {
  background-color: rgba(255, 255, 255, 0.5);
}
#login mat-card .theme-company-logo {
  height: 120px;
  width: 100%;
  background: transparent url("/assets/img/synlogo.png") 50% no-repeat;
}
#login mat-card .full-width {
  width: 100%;
}
#login mat-card .error {
  color: crimson;
  text-align: center;
  margin: 10px 0;
}
#login .second-eterno-input {
  margin-top: 15px;
}
#login .bloc-forget-password {
  text-align: center;
  margin-top: 17px;
}
#login .bloc-forget-password .forget-password {
  color: #2c2b4a;
  text-decoration-line: underline;
  cursor: pointer;
}
#login .bloc-button-login {
  margin-top: 22px;
}
#login .bloc-no-account {
  margin-top: 25px;
  font-weight: bold;
  font-family: "DM Sans";
}
#login .bloc-no-account p {
  font-size: 14px;
  color: #2c2b4a;
}
#login .bloc-no-account a {
  cursor: pointer;
  color: #5620e4;
  text-decoration-line: underline;
}

.logo-below {
  position: absolute;
  background: transparent url(/assets/img/synlogo.png);
  background-repeat: no-repeat;
  height: 81px;
  width: 100px;
  left: 76%;
  top: 86.25%;
}

.copyright {
  height: 81px;
  width: 100px;
  left: 85%;
  top: 94%;
  position: absolute;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/form-login/form-login.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6EAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EA0DA,2HAAA;AAxDF;AAAE;EACE,qCAAA;EACA,gDAAA;EACA,mCAAA;UAAA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAEJ;AAAI;EACE,UAAA;EACA,YAAA;AAEN;AACI;EACE,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AACN;AACM;EACE,cAAA;EACA,eAAA;AACR;AAEM;EACE,eAAA;EACA,YAAA;EACA,qBAAA;AAAR;AAGM;EACE,YAAA;EACA,YAAA;AADR;AAIM;EACE,YAAA;EACA,YAAA;AAFR;AAOE;EACE,YAAA;EACA,gBAAA;AALJ;AAOI;EACE,eAAA;AALN;AAQI;EACE,iBAAA;EACA,gBAAA;AANN;AAUE;EAGE,0CAAA;AAVJ;AAYI;EACE,aAAA;EACA,WAAA;EACA,oEAAA;AAVN;AAaI;EACE,WAAA;AAXN;AAcI;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AAZN;AAgBE;EACE,gBAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,gBAAA;AAfJ;AAiBI;EACE,cAAA;EACA,+BAAA;EACA,eAAA;AAfN;AAqBE;EACE,gBAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;AApBJ;AAsBI;EACE,eAAA;EACA,cAAA;AApBN;AAuBI;EACE,eAAA;EACA,cAAA;EACA,+BAAA;AArBN;;AAyBE;EACE,kBAAA;EACA,oDAAA;EACA,4BAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AAtBJ;;AAyBE;EACE,YAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;AAtBJ;;AAwBA;EACE,kCAAA;AArBF","sourcesContent":["#login {\r\n  font-weight: 400;\r\n  font-size: 0.8em;\r\n  line-height: 1.6em;\r\n  font-family: \"Open Sans\", Frutiger, Calibri, \"Myriad Pro\", Myriad, sans-serif;\r\n  color: #000;\r\n  text-align: center;\r\n  /* Flex container */\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  .card-login {\r\n    background: rgba(251, 253, 248, 0.68);\r\n    box-shadow: 11px 16px 83px rgba(64, 75, 5, 0.28);\r\n    backdrop-filter: blur(10px);\r\n    width: 557px;\r\n    height: 415px;\r\n    border-radius: 22px;\r\n\r\n    .content {\r\n      width: 90%;\r\n      margin: auto;\r\n    }\r\n\r\n    .bloc-page-title {\r\n      margin-top: 30px;\r\n      text-align: center;\r\n      font-size: \"DM Sans\";\r\n      font-weight: 700;\r\n      margin-bottom: 20px;\r\n\r\n      .page-title {\r\n        color: #5620e4;\r\n        font-size: 28px;\r\n      }\r\n\r\n      .sub-title {\r\n        font-size: 12px;\r\n        opacity: 0.8;\r\n        letter-spacing: 0.7px;\r\n      }\r\n\r\n      .img-logo{\r\n        height: 80px;\r\n        width: 151px;\r\n      }\r\n\r\n      .img-logo-telespazio {\r\n        height: 80px;\r\n        width: 270px;\r\n      } \r\n    }\r\n  }\r\n\r\n  .bloc-infos-login {\r\n    color: white;\r\n    text-align: left;\r\n\r\n    .title {\r\n      font-size: 5rem;\r\n    }\r\n\r\n    .details {\r\n      font-size: 1.1rem;\r\n      margin-top: 45px;\r\n    }\r\n  }\r\n  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */\r\n  mat-card {\r\n    //width: 30%;\r\n    //margin: 200px auto;\r\n    background-color: rgba(255, 255, 255, 0.5);\r\n\r\n    .theme-company-logo {\r\n      height: 120px;\r\n      width: 100%;\r\n      background: transparent url(\"/assets/img/synlogo.png\") 50% no-repeat;\r\n    }\r\n\r\n    .full-width {\r\n      width: 100%;\r\n    }\r\n\r\n    .error {\r\n      color: crimson;\r\n      text-align: center;\r\n      margin: 10px 0;\r\n    }\r\n  }\r\n\r\n  .second-eterno-input {\r\n    margin-top: 15px;\r\n  }\r\n\r\n  .bloc-forget-password {\r\n    text-align: center;\r\n    margin-top: 17px;\r\n\r\n    .forget-password {\r\n      color: #2c2b4a;\r\n      text-decoration-line: underline;\r\n      cursor: pointer;\r\n    }\r\n  }\r\n\r\n\r\n\r\n  .bloc-button-login {\r\n    margin-top: 22px;\r\n  }\r\n\r\n  .bloc-no-account {\r\n    margin-top: 25px;\r\n    font-weight: bold;\r\n    font-family: \"DM Sans\";\r\n\r\n    p {\r\n      font-size: 14px;\r\n      color: #2c2b4a;\r\n    }\r\n\r\n    a {\r\n      cursor: pointer;\r\n      color: #5620e4;\r\n      text-decoration-line: underline;\r\n    }\r\n  }\r\n}\r\n  .logo-below {\r\n    position: absolute;\r\n    background: transparent url(/assets/img/synlogo.png);\r\n    background-repeat: no-repeat;\r\n    height: 81px;\r\n    width: 100px;\r\n    left: 76%;\r\n    top: 86.25%;\r\n  }\r\n\r\n  .copyright {\r\n    height: 81px;\r\n    width: 100px;\r\n    left: 85%;\r\n    top: 94%;\r\n    position: absolute;  ;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
